export default {
	missing: 'Puudub kuupäev',
	olderThan: 'Vanemad kui {timePeriod}',
	dueIn: 'Järgmised {timePeriod} päeva',
	overduePeriod: 'Eelnenud {timePeriod} päeva',
	overdue: 'Kõik tähtaja ületanud',
	daysExceeded: 'Eelnevad',
	daysRemaining: 'Järgmised',
	todaysDate: 'Tänane kuupäev',
	ontime: 'Kõik tulevased tähtajad',
	month: 'kuu aega',
	threeMonths: 'kolm kuud',
	halfYear: 'pool aastat',
	year: 'aasta',
}
